export enum AreaSizeDescription {
  ONE_COLUMN = 'One Column',
  TWO_COLUMN = 'Two Column',
  THREE_COLUMN = 'Three Column',
  FOUR_COLUMN = 'Four Column',
}
